import API from './api';

export const timesheetService = {
  // Get timesheets list
  getTimesheets: (params) => API.get('/timesheets', { params }),
  
  // Check attendance status for timesheet eligibility
  checkAttendanceForTimesheet: (workDate) => API.get('/timesheets/check-attendance', { params: { work_date: workDate } }),
  
  // Get single timesheet by ID
  getTimesheetById: (id) => API.get(`/timesheets/${id}`),
  
  // Create timesheet entry
  createTimesheet: (data) => API.post('/timesheets', data),

  // ADDED: Bulk create timesheet entries for a date range
  bulkCreateTimesheet: (data) => API.post('/timesheets/bulk', data),
  
  // Download timesheet attachment
  downloadTimesheetAttachment: (attachmentId) => API.get(`/timesheets/attachments/${attachmentId}/download`, {
    responseType: 'blob'
  }),
  
  // Update timesheet entry
  updateTimesheet: (id, data) => API.put(`/timesheets/${id}`, data),
  
  // Submit timesheet
  submitTimesheet: (id) => API.put(`/timesheets/${id}/submit`),
  
  // Bulk submit timesheets
  bulkSubmitTimesheets: (data) => API.put('/timesheets/bulkSubmit/update', data),
  
  // Review timesheet
  reviewTimesheet: (id, data) => API.put(`/timesheets/${id}/review`, data),
  
  // Bulk review timesheets
  bulkReviewTimesheets: (data) => API.put('/timesheets/bulkReview/update', data),
  
  // Delete timesheet
  deleteTimesheet: (id) => API.delete(`/timesheets/${id}`),
  
  // Get timesheet summary for employee
  getTimesheetSummary: (employeeId, params) => API.get(`/timesheets/summary/${employeeId}`, { params }),
  
  // Get timesheet report
  getTimesheetReport: (params) => API.get('/timesheets/reports/summary', { params }),
  
  // Upload Excel file for bulk timesheet import
  uploadExcelFile: (formData) => API.post('/timesheets/upload-excel', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  }),

  // Download sample timesheet template
  downloadSampleTemplate: () => API.get('/timesheets/download-sample-template', {
    responseType: 'blob'
  }),
};